module.exports = __webpack_public_path__ + "static/media/trophy.639937aa.svg";